import globals from '../common/globals';
import CartDrawer from '../common/cartDrawer';
import { urlencodeFormData } from './utilities';

const Store = {
  openCartDrawer: true,
  openCartDrawerMobile: true,
  useSubscription: globals.useSubscription || false,
  attrSubscription: globals.attrSubscription || 3,

  addProduct: function (form, parent, callback) {
    // Tratativa para bundle nativo
    if (form.hasAttribute('data-bundle-section')) {
      Store.addBundle(form, parent);
      return;
    }

    // Se tiver customizações, ajusta campos de texto que não foram preenchidos
    const customizations = form.querySelectorAll('[data-customization]');
    const quantity = Number(form.querySelector('[name="quantity"]').value);
    if (customizations.length > 0)
      customizations.forEach((custom) => {
        const type = custom.getAttribute('type');

        if (type !== 'checkbox' || type !== 'radio') {
          if (custom.value === '') {
            custom.setAttribute('disabled', true);
          }
        }
      });

    // Item com assinatura
    if (Store.useSubscription && form.hasAttribute('data-product-subscription')) {
      Store.addSubscription(form, parent);
    } else {
      if (customizations.length > 0 && quantity > 1) {
        // Item com personalização e com quantidade alta
        Store.addItemsCustom(form, parent, callback);
      } else {
        // Item com quantidade 1, com ou sem personalização
        Store.addItem(form, parent, callback);
      }
    }
  },

  addBundle: async function (form, parent) {
    let bundle_skus = [];

    const bundleProducts = form.querySelectorAll('[data-product-box]');
    bundleProducts.forEach((product) => {
      bundle_skus.push(product.querySelector('[name="sku"]').value);
    });

    const bundleObj = {
      sku: document.querySelector('[data-main-bundle-product-id]').value,
      quantity: 1,
      bundle_skus,
    };

    let formBody = [];
    for (const key in bundleObj) {
      if (bundleObj.hasOwnProperty(key)) {
        const value = bundleObj[key];

        // Lida com a array de bundle_skus
        if (key === 'bundle_skus' && Array.isArray(value)) {
          value.forEach((item) => {
            formBody.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
          });
        } else {
          // Lida com as demais propriedades que não são array
          const encodedValue = Array.isArray(value)
            ? value.map((item) => encodeURIComponent(item)).join(',')
            : encodeURIComponent(value);
          formBody.push(`${encodeURIComponent(key)}=${encodedValue}`);
        }
      }
    }

    formBody = formBody.join('&');

    try {
      while (true) {
        const response = await fetch('/carrinho/adicionar', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json, text/javascript, */*; q=0.01',
          },
          body: formBody,
        });

        if (response.status === 202) {
          const retryAfter = response.headers.get('Retry-After');
          const delay = retryAfter ? parseInt(retryAfter, 10) : 3000; // Default 3s se não houver Retry-After
          console.info(`Tentando novamente em ${delay} ms...`);
          await new Promise((resolve) => setTimeout(resolve, delay));
        } else {
          if (!response.ok) {
            const text = await response.text();
            console.error('addBundle - Erro na requisição de adição de produto.');
            console.error(response);
            console.error(text);

            const button = form.querySelector('[data-bundle-add]');
            if (button) {
              button.classList.add('-unavailable');

              const innerHTML = button.innerHTML;
              button.innerHTML = 'Erro ao adicionar no carrinho';

              setTimeout(() => {
                button.classList.remove('-unavailable');
                button.innerHTML = innerHTML;
              }, 2000);
            }

            return;
          }

          const data = await response.json();
          console.log('addBundle - success', data);

          CartDrawer.show();
          break;
        }
      }
    } catch (error) {
      console.log('addBundle - error');
      console.log(error);

      const button = form.querySelector('[data-bundle-add]');
      if (button) {
        button.classList.add('-unavailable');

        const innerHTML = button.innerHTML;
        button.innerHTML = 'Erro ao adicionar no carrinho';

        setTimeout(() => {
          button.classList.remove('-unavailable');
          button.innerHTML = innerHTML;
        }, 2000);
      }
    }
  },

  addSubscription: async function (form, parent) {
    const planInput = form.querySelector(`[data-attribute="${Store.attrSubscription}"] input:checked`);
    if (!planInput) return;

    const btnComprar = parent.querySelector('[data-action="add-cart"]');
    const urlAdd = '/assinaturas/carrinho/itens';

    let data = {};
    data.subscription_item = {
      quantity: form.querySelector('[name="quantity"]').value,
      sku: form.querySelector('[name="sku"]').value,
      extra: {
        vindi_plan_id: planInput.value,
      },
    };

    const json_data = JSON.stringify(data);

    if (!btnComprar.classList.contains('-adding')) {
      btnComprar.classList.add('-adding');

      try {
        const response = await fetch(urlAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/javascript, */*; q=0.0',
            'Content-Type': 'application/json',
          },
          body: json_data,
        });

        if (response.ok) {
          window.location.href = '/assinaturas/carrinho';
        } else {
          console.error('addSubscription - Erro na requisição de adição de assinatura.');
          console.error(response);
        }
      } catch (error) {
        console.log('addSubscription - error');
        console.error(error);
      }

      btnComprar.classList.remove('-adding');
    }
  },

  addItemsCustom: async function (form, parent, callback) {
    const _this = this;
    const btnComprar = parent.querySelector('[data-action="add-cart"]');
    const boxResponse = parent.querySelector('[data-form-product] .msg-response:not(.resp-validate)');
    const quantity = Number(form.querySelector('[name="quantity"]').value);
    let hasCustoms = false;
    let customs = {};

    // Prepara o item e suas personalizações
    let data = {
      items: [
        {
          sku: form.querySelector('[name="sku"]').value,
          quantity,
          customizations: [],
        },
      ],
    };

    const customizations = form.querySelectorAll('[data-customization]');
    if (customizations.length > 0)
      customizations.forEach((custom) => {
        const disabled = custom.getAttribute('disabled');
        const type = custom.getAttribute('type');
        let checked = true;
        if (type !== 'text' && type !== 'textarea') checked = custom.checked;

        if (checked && disabled !== 'true') {
          hasCustoms = true;
          if (type === 'text' || type === 'textarea') {
            customs[custom.getAttribute('data-customization-name')] = custom.value;
          } else {
            customs[custom.getAttribute('data-customization-name')] = custom.getAttribute('value');
          }
        }
      });

    if (hasCustoms) {
      for (let index = 0; index < quantity; index++) {
        data.items[0].customizations.push(customs);
      }
    }

    const json_data = JSON.stringify(data);

    console.info('addItemsCustom');
    // console.log(json_data)

    // Envia o produto com suas personalizações
    if (!btnComprar.classList.contains('-adding')) {
      btnComprar.classList.add('-adding');

      try {
        const response = await fetch('/carrinho/adicionar/kit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: json_data,
        });

        const html = await response.text();

        if (response.ok) {
          console.log('addItemsCustom - success');
          if (typeof callback == 'function') {
            callback('produto-adicionado', html, boxResponse, form);
          } else {
            _this.addItemResult('produto-adicionado', html, boxResponse, form);
          }
        } else {
          console.log('addItemsCustom - server não reconheceu adição');
          if (typeof callback == 'function') {
            callback('erro-adicionar', error, boxResponse, form);
          } else {
            _this.addItemResult('erro-adicionar', error, boxResponse, form);
          }
        }
      } catch (error) {
        console.log('addItemsCustom - error');
        console.error(error);

        if (typeof callback == 'function') {
          callback('erro-adicionar', error, boxResponse, form);
        } else {
          _this.addItemResult('erro-adicionar', error, boxResponse, form);
        }
      }

      customizations.forEach((custom) => {
        custom.removeAttribute('disabled');
      });

      btnComprar.classList.remove('-adding');
    }
  },

  addItem: async function (form, parent, callback) {
    const _this = this;
    const btnComprar = parent.querySelector('[data-action="add-cart"]');
    const urlAdd = '/carrinho/adicionar';
    const formData = urlencodeFormData(new FormData(form));
    const boxResponse = parent.querySelector('[data-form-product] .msg-response:not(.resp-validate)');

    if (!btnComprar.classList.contains('-adding')) {
      btnComprar.classList.add('-adding');

      try {
        while (true) {
          const response = await fetch(urlAdd, {
            method: 'POST',
            headers: {
              Accept: 'application/json, text/javascript, */*; q=0.0',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: formData,
          });

          if (response.status === 202) {
            const retryAfter = response.headers.get('Retry-After');
            const delay = retryAfter ? parseInt(retryAfter, 10) : 3000; // Default 3s se não houver Retry-After
            console.info(`Tentando novamente em ${delay} ms...`);
            await new Promise((resolve) => setTimeout(resolve, delay));
          } else {
            if (!response.ok) {
              const text = await response.text();
              console.error('addItem - Erro na requisição de adição de produto.');
              console.error(response);
              console.error(text);
              return;
            }

            const data = await response.json();
            console.log('addItem - success', data);

            if (typeof callback === 'function') {
              callback('produto-adicionado', data, boxResponse, form);
            } else {
              _this.addItemResult('produto-adicionado', data, boxResponse, form);
            }
            break;
          }
        }
      } catch (error) {
        console.log('addItem - error');
        console.error(error);

        if (typeof callback === 'function') {
          callback('erro-adicionar', error, boxResponse, form);
        } else {
          _this.addItemResult('erro-adicionar', error, boxResponse, form);
        }
      }

      btnComprar.classList.remove('-adding');
    }
  },

  deleteItem: async function (itemId, item, removeItemResult) {
    const _this = this;

    try {
      const body = new URLSearchParams({
        _method: 'DELETE',
        item_id: itemId,
      });

      const response = await fetch('/carrinho', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json, text/javascript, */*; q=0.01',
        },
        body,
      });

      console.log('success');

      if (window.innerWidth > 768) {
        if (_this.openCartDrawer) {
          CartDrawer.updateCartCount();
        }
      } else {
        if (_this.openCartDrawerMobile) {
          CartDrawer.updateCartCount();
        }
      }

      if (typeof removeItemResult == 'function') {
        removeItemResult(item);
      }
    } catch (error) {
      console.log('Erro ao remover item do carrinho');
      console.log(error);
    }
  },

  validateFormProduct: function (form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var btnComprar = form.querySelector('[data-action="add-cart"]');
    var validated = true;
    var errors = [];

    if (btnComprar.dataset.available == 'false') {
      validated = false;
      errors.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (form.querySelector('[name="sku"]').value == '') {
        validated = false;
        errors.push('Selecione um atributo para o produto');
      }

      //  verifica se a quantidade é válida
      if (form.querySelector('input[name="quantity"]').value <= 0) {
        validated = false;
        errors.push('Quantidade indisponível');
      }
    }

    return { validated, errors };
  },

  setRespValidateProduct: function (resp, form, boxResponse) {
    let htmlErrors = '';

    if (resp.validated) {
      boxResponse.innerHTML = '';
    } else {
      for (var i = resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + resp.errors[i] + '</span>';
      }
      boxResponse.innerHTML = htmlErrors;
    }
  },

  addItemResult: function (typeResult, result, boxResponse, form) {
    const _this = this;

    if (typeResult == 'produto-adicionado') {
      const btnComprar = form.querySelector('[data-action="add-cart"]');

      if (btnComprar) btnComprar.classList.add('success');

      setTimeout(function () {
        if (btnComprar) btnComprar.classList.remove('success');
        if (btnComprar) btnComprar.innerHTML = btnComprar.dataset.textAvailable;
      }, 3500);

      // CartDrawer.updateCartCount();

      if (window.innerWidth > 768) {
        if (_this.openCartDrawer) {
          CartDrawer.show();
        } else {
          setTimeout(() => {
            window.location.href = urlCart;
          }, 150);
        }
      } else {
        if (_this.openCartDrawerMobile) {
          CartDrawer.show();
        } else {
          setTimeout(() => {
            window.location.href = urlCart;
          }, 150);
        }
      }

      // Verifica se há popup de compra rápida ativo. Se tiver, fecha ele
      // Retirar ou comentar se não for utilizado
      const popupQuickview = document.querySelectorAll('[data-popup-quickview]');
      popupQuickview.length > 0 &&
        popupQuickview.forEach((popup) => {
          if (popup.classList.contains('-active')) {
            popup.querySelector('[data-close-popup-quickview]').click();
          }
        });

      // Remove disabled das personalizações de texto, se existirem
      const customizations = form.querySelectorAll('[data-customization]');
      if (customizations.length > 0)
        customizations.forEach((custom) => {
          const type = custom.getAttribute('type');
          if (type !== 'checkbox' || type !== 'radio') {
            custom.removeAttribute('disabled');
          }
        });
    } else if (typeResult == 'erro-adicionar') {
      if (typeof boxResponse != 'undefined' && boxResponse.length > 0) {
        window.scrollTo({
          top: boxResponse.offsetTop,
          behavior: 'smooth',
        });

        boxResponse.classList.add('error');
        boxResponse.classList.remove('success');
        boxResponse.querySelector('span').innerHTML = 'Ocorreu um erro, tente novamente.';
      }
    }
  },

  buyNow: async function (button) {
    if (button.classList.contains('-adding')) return;

    const sku = button.dataset.sku;
    const quantity = 1;
    const originalText = button.innerHTML;

    button.classList.add('-adding');
    button.innerHTML = 'Aguarde...';

    try {
      const response = await fetch('/carrinho/adicionar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json, text/javascript, */*; q=0.01',
        },
        body: `sku=${encodeURIComponent(sku)}&quantity=${quantity}`,
      });

      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        console.error('Erro ao comprar agora');
        button.classList.remove('-adding');
        button.innerHTML = originalText;
      }
    } catch (error) {
      console.error(error);
      button.classList.remove('-adding');
      button.innerHTML = originalText;
    }
  },
};

document.addEventListener('click', (e) => {
  const button = e.target.closest('[data-buy-now]');
  if (button) {
    e.preventDefault();
    Store.buyNow(button);
  }
});

export default Store;
